var result_obj = {
			declOfNum: (number, titles) => {
			    let cases = [2, 0, 1, 1, 1, 2];  
			    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];  
			},
			point: () => {
				let points = 0;
				for (let key in result_obj.data) {
					if ((result_obj.data[key].val) && (result_obj.data[key].val !== 'undefined')) {

						switch (result_obj.data[key].val) {
							case 'low': 
								points = points + result_obj.data[key].point_low;
							break;
							case 'average':
								points = points + result_obj.data[key].point_average;
							break;
							case 'normal':
								points = points + result_obj.data[key].point_normal;
							break;
							case 'good':
								points = points + result_obj.data[key].point_good;
							break;
							case 'great':
								points = points + result_obj.data[key].point_great;
							break;
							default: 
								points = points + result_obj.data[key].point;
						}
	
					}
				}
				return points;
			},
			getpercent: (int) => {
				 return int / Object.keys(result_obj.data).length * 100;
			},
			skipresult: () => {
				for (let key in result_obj.data) {
					result_obj.data[key].finish = false;
					result_obj.data[key].val = false;
				}
				return true;
			},
			finished: () => {
				let finish = 0;
				for (let key in result_obj.data) {
					if (result_obj.data[key].finish) {
						finish = finish + 1;
					}
				}
				return finish;
			},
			set: {
				can_message: (data) => {
					if (data.can_message === 1) { 
						result_obj.data.messages.val = true;
					} else {
						result_obj.data.online.finish = true;
						result_obj.data.online.val = 'undefined';
					}
					result_obj.data.messages.finish = true;
				},
				cover: (data) => {
					if (data.cover.enabled === 1) {
						result_obj.data.cover.val = true;
					}
					result_obj.data.cover.finish = true;
				},
				market: (data) => {
					if (data.market.enabled === 1) { 
						result_obj.data.market.val = true;
					}
					result_obj.data.market.finish = true;
				},
				type: (data) => {
					if (data.type === 'page') { 
						result_obj.data.group_or_public.val = true;
					}
					result_obj.data.group_or_public.finish = true;
				},
				screen_name: (data) => {
					if (Number(data.screen_name.replace(/club/g,"").replace(/public/g,"")) === data.id) {
						result_obj.data.screen_name.val = false;
					} else {
						result_obj.data.screen_name.val = true;
					}
					
					result_obj.data.screen_name.finish = true;
				},
				age_limits: (data) => {
					if (data.age_limits === 1) {
						result_obj.data.age_limits.val = true;
					}
					result_obj.data.age_limits.finish = true;
				},
				description: (data) => {
					if (data.description.length >= 5) {
						result_obj.data.description.val = true;
					}
					result_obj.data.description.finish = true;
				},
				main_section: (data) => {
					if (data.main_section !== 0) {
						result_obj.data.main_section.val = true;
					}
					result_obj.data.main_section.finish = true;
				},
				links: (data) => {
					let result_links = [];

					if (data.links) {
						for (let key in data.links) {
							let url = data.links[key].url;
							let id_gid = data.id;
							let screen_name_gid = data.screen_name;
							

							if(url.indexOf('vk.com') + 1) {
								//Это ссылка на vk
								if(url.indexOf(id_gid) + 1) {
									//есть группа 
									result_links.push(0);
								} else {
									//нет группы, может быть есть скрин нейм?
									if (url.indexOf(screen_name_gid) + 1) {
										//Да есть скрин нейм
										result_links.push(0);
									}
								}
							} else {
								result_links.push(1);
							}
						}

						
						if (result_links.indexOf( 1 ) !== -1) {
							result_obj.data.links.val = false;
						} else {
							result_obj.data.links.val = true;
						}
		

					} else {
						result_obj.data.links.val = true; //если вообще нет ссылок
					}
					result_obj.data.links.finish = true;
				},
				contacts: (data) => {
					let result_contacts = [];
					
					for (let key in data.contacts) {
						if (data.contacts[key].user_id) {
							result_contacts.push(1);
						} else {
							result_contacts.push(0);
						}
					}

					if (result_contacts.indexOf( 1 ) !== -1) {
						result_obj.data.contacts.val = true;
					} else {
						result_obj.data.contacts.val = false;
					}
		
					result_obj.data.contacts.finish = true;
				},
				GetTargetWall: (data, fixed_post, target) => {
					let сoefofinv = []; //массив с коэффициентом вовлечения каждого поста
					let post_repost = []; //массив с проверкой на репост каждого поста
					let all_date_posts = []; //все даты публикаций
					let all_post_hashtag = []; //все посты с хештегами
 
					if (data.count !== 0) { //есть ли вообще посты?

						for (let key in data.items) { //пробегаем все посты
							/* Получение коэффицента вовлечения каждого поста*/
							if ((data.items[key].views) && (fixed_post !== data.items[key].id)) { //проверка на то есть ли просмотры вообще у поста.
								let comments_count = Number(data.items[key].comments.count);
								let likes_count = Number(data.items[key].likes.count);
								let views_count = Number(data.items[key].views.count);

								if ((likes_count + comments_count) !== 0) { //Не должно осуществляться деление на ноль.
									let to_arr = Math.round(views_count / (likes_count + comments_count));
									сoefofinv.push(to_arr);
								}

							}
							/* Получение статуса репоста каждого поста*/
							if (data.items[key].copy_history) {
								post_repost.push(1); //репост
							} else {
								post_repost.push(0); //не репост
							}
							/* Получение всех дат публикай поста */
							if (fixed_post !== data.items[key].id) {
								all_date_posts.push(data.items[key].date);
							}
							/* Получение постов с хештегами */
							if (data.items[key].text.length >= 2) { //Если в посте есть хотя бы 2 символа

								if(data.items[key].text.indexOf('#') + 1) { //в посте есть хештег
									let arr_hash_post = data.items[key].text.split(' ');
									arr_hash_post.forEach((it) => { //спроверяем каждое слово
										if(it.indexOf('#') + 1) { //Есть хештег в слове
											// проверям хештег ли это сообщества
											if(it.indexOf('@'+target.screen_name) + 1) {
											} else {
												all_post_hashtag.push(1); //Есть хештег
											} 
										} 
									})	
								} else {
									all_post_hashtag.push(0); //Нет хештегов
								}

							}
						}

						//Выводим средний коэффициент вовлечения для всех постов.	
						let sum = 0;
						let involvement;

						сoefofinv.forEach(function(item) {
							sum = sum + item;
						});
						if ((sum === 0) || (сoefofinv.length === 0)) {
							involvement = 0;
						} else {
							involvement = Math.round(Number(sum) / Number(сoefofinv.length));
						}

						

						//распределяем насколько хорош коэффициент вовлечения (involvement)
						if ((involvement > 0) || (involvement >= 61)) {
							result_obj.data.involvement.val = 'low';
							result_obj.data.involvement.text_low = `Сейчас вовлекается в активности каждый ${involvement}, просмотревший пост. Это крайне низкий показатель. ВКонтакте работает умная лента, которая анализирует лайки и комментарии пользователей (а также еще множество факторов) и, исходя из этого, распределяет охваты. \n\n К сожалению, далеко не все пользователи соцсети видят новости сообщества, чтобы дважды не платить за рекламу по аудитории, которую и без того привлекли — срочно нужно работать над вовлечением. Как это делать я рассказала на прямой трансляции (ссылка на запись в последнем блоке), а еще мы с Церебро подготовили курс, где по шагам мы учим прокачивать активности, которые повышают продажи в разы. Ссылку на курс Вы так же найдёте в блоке полезных ссылок.`;
						}
						if ((involvement >= 36) && (involvement <= 60)) {
							result_obj.data.involvement.val = 'average';
							result_obj.data.involvement.text_average = `Сейчас вовлекается в активности каждый ${involvement}, просмотревший пост. Это средний показатель. ВКонтакте работает умная лента, которая анализирует лайки и комментарии пользователей (а также еще множество факторов) и, исходя из этого, распределяет охваты. \n\n К сожалению, далеко не все пользователи соцсети видят новости сообщества, чтобы дважды не платить за рекламу по аудитории, которую и без того привлекли — срочно нужно работать над вовлечением. Как это делать я рассказала на прямой трансляции (ссылка на запись в последнем блоке)`;
						}
						if ((involvement >= 15) && (involvement <= 35)) {
							result_obj.data.involvement.val = 'normal';
							result_obj.data.involvement.text_normal = `Сейчас вовлекается в активности каждый ${involvement}, просмотревший пост. Это хороший показатель. Видно, что администратор работает с аудиторией! Отлично! \n\n Напомню, что умная лента ВКонтакте дает повышенные охваты сообществам, которые умеют привлекать внимание пользователей к публикациям.`;
						}
						if ((involvement >= 1) && (involvement <= 14)) {
							result_obj.data.involvement.val = 'good';
							result_obj.data.involvement.text_good = `Сейчас вовлекается в активности каждый ${involvement}, просмотревший пост. Это отличный показатель. Видно, что администратор работает с аудиторией! Отлично! \n\n Напомню, что умная лента ВКонтакте дает повышенные охваты сообществам, которые умеют привлекать внимание пользователей к публикациям.`;
						}
						if (involvement === 0) {
							result_obj.data.involvement.val = 'undefined';
						}
						//Выводим процент постов, которые являются репостами

						let precent_reposts;
						let all;							
						let result_post_repost = post_repost.reduce(function(acc, el) {
							acc[el] = (acc[el] || 0) + 1;
							return acc;
						}, {});

						if (result_post_repost[1]) {
							if (result_post_repost[0]) {
								all = result_post_repost[0] + result_post_repost[1];
								precent_reposts = Math.round(Number(result_post_repost[1]) / Number(all) * 100);
							} else {
								precent_reposts = 100;
							}
						} else {
							precent_reposts = 0;
						}

						//распределяем насколько хорош процент репостов (precent_reposts)
						if (precent_reposts === 0) {
							result_obj.data.reposts.val = 'normal';
						}
						if ((precent_reposts > 0) && (precent_reposts <= 5)) {
							result_obj.data.reposts.val = 'average';
						}
						if (precent_reposts >= 6) {
							result_obj.data.reposts.val = 'low';
						}



						//Выводим среднюю разницу между публикациями
						let post_difference= [];
						let difference;
						all_date_posts.forEach(function(e, i) { //все разрывы между публикациями
							let a, raz;
							if (i+1 < all_date_posts.length) {
								a = i + 1; //all_date_posts[a] следующий элемент
								raz = all_date_posts[i] - all_date_posts[a];
								post_difference.push(raz);
							}
						});
						sum = 0;
						post_difference.forEach(function(item) { //среднее значение разрывов между публикациями.
							sum = sum + item;
						});
						if ((sum === 0) || (post_difference.length === 0)) {
							difference = 0;
						} else {
							difference = Math.round(Number(sum) / Number(post_difference.length));
							difference = Math.round(difference / 3600); //Разрывы выводим в часах
						}

						//распределяем насколько хорошее среднее время между публикациями (difference)

						if (difference >= 25) {
							result_obj.data.difference.val = 'low';
							result_obj.data.difference.text_low = `Среднее время между публикациями сейчас равно ${difference+' '+result_obj.declOfNum(difference, ['час', 'часа', 'часов'])}. \n\n К сожалению, сейчас далеко не все подписчики видят публикации сообщества, средний показатель находится около 10% от общего числа. ВКонтакте на мероприятии VK Talents Event 2018 сообщил о том, что для наилучшего присутствия в умной ленте следует делать 3-5 уникальных публикаций в день.`;
						}
						if ((difference >= 12) && (difference <= 24)) {
							result_obj.data.difference.val = 'normal';
							result_obj.data.difference.text_normal = `Среднее время между публикациями сейчас равно ${difference+' '+result_obj.declOfNum(difference, ['час', 'часа', 'часов'])}. \n\n Здорово, что администратор старается публиковать, хотя бы один пост в день. Чтобы отдача от сообщества была выше, нужно увеличить их количество. ВКонтакте с авторами рекомендуют делать 3-5 уникальных публикаций в день. За счет этого повысятся охваты, и больше подписчиков увидят новости сообщества.`;
						}
						if ((difference >= 3) && (difference <= 12)) {
							result_obj.data.difference.val = 'good';
							result_obj.data.difference.text_good = `Среднее время между публикациями сейчас равно ${difference+' '+result_obj.declOfNum(difference, ['час', 'часа', 'часов'])}. Это идеальное количество публикаций в день, главное не стоит постить чаще 6 раз в день, если это сообщество не СМИ.`;
						}
						if ((difference >= 1) && (difference <= 2)) {
							result_obj.data.difference.val = 'average';
							result_obj.data.difference.text_average = `Среднее время между публикациями сейчас равно ${difference+' '+result_obj.declOfNum(difference, ['час', 'часа', 'часов'])}. В сообществе очень частые публикации, если сообщество не СМИ, то лучше снизить их количество до 3-6 постов. Рекомендация основана на выступлении представителя ВКонтакте на VK Talents Event 2018.`;
						}
						if (difference === 0) {
							result_obj.data.difference.val = 'undefined';
						}


						//выводим процент постов с хештегами
						let precent_hastag;
						let result_post_hastag = all_post_hashtag.reduce(function(acc, el) {
							acc[el] = (acc[el] || 0) + 1;
							return acc;
						}, {});	
						if (result_post_hastag[1]) {
							all = result_post_hastag[0] + result_post_hastag[1];
							precent_hastag = Math.round(Number(result_post_hastag[1]) / Number(all) * 100); 	
						} else {
							precent_hastag = 0;
						}

						//распределяем насколько хороший процент постов с хештегами (precent_hastag)

						if (precent_hastag <= 5) {
							result_obj.data.hashtag.val = true;
						} else {
							result_obj.data.hashtag.val = false;
						}
				


					} else { //если вообще нет постов, то эти блоки не показваются
						result_obj.data.reposts.val = 'undefined'; //репосты
						result_obj.data.involvement.val = 'undefined';	//вовлечение
						result_obj.data.difference.val = 'undefined'; //время между публикациями
						result_obj.data.hashtag.val = 'undefined'; //процент хештегов
					}

					result_obj.data.difference.finish = true;
					result_obj.data.reposts.finish = true;
					result_obj.data.involvement.finish = true;
					result_obj.data.hashtag.finish = true;
				},
				online: (data) => {

						switch (data.status) {
							case 'none':
								//Сообщество сейчас не онлайн
							break;
							case 'online':
								//Отвечает мнгновенно
								result_obj.data.online.val = true;
							break;
							case 'answer_mark':
								//Быстро отвечает
								if (data.minutes < 5) {
									result_obj.data.online.val = true;
								}
							break;
							default:
								
							}

					result_obj.data.online.finish = true;

				},
			},
			data:{
				screen_name: {
					finish:false,
					name:"Короткая ссылка",
					val: false,
					point:3,
					text_yes: `Классная короткая ссылка у сообщества. Администратор правильно сделал, поменяв стандартную числовую ссылку на уникальную.`,
					text_no: `ВКонтакте есть возможность менять стандартную ссылку сообщества на свою уникальную. Индивидуальный адрес выглядит презентабельней и вызывает больше доверия у целевой аудитории. Добавить можно прямо сейчас: «управление сообществом» -> «настройки» -> «адрес страницы».`
				},
				age_limits: {
					finish:false,
					name:"Ограничения",
					val: false,
					point:6,
					text_yes: `В сообществе нет возрастных ограничений. Оно открывается и на iOS, и на Android.`,
					text_no: `В сообществе установлены возрастные ограничения, их нужно срочно убрать:( Некоторые предприниматели считают, что установка возрастных ограничений как-то будет способствовать зрелости аудитории в их группах, но яблочные устройства несколько иначе воспринимают данную информацию. Если есть ограничение 16+, то, даже если Вы продаете станки ЧПУ, Apple будет думать, что в группе легкая эротика и закроет доступ даже 37-летнему мужчине. Политика компании строится в ограничении своих пользователей от порно индустрии, не зависимо от возраста. \n\n Как изменить возрастные ограничения: «управление сообществом» -> «настройки» -> «возраст до 16 лет».`
				},
				group_or_public: {
					finish:false,
					name:"Тип сообщества",
					val: false,
					point:6,
					text_yes: `Сообщество имеет форму публичной страницы, оно отображается на страницах пользователей в разделе «Интересные страницы», что является бесплатной рекламой и привлекает внимание потенциальных клиентов.`,
					text_no: `Сообщество имеет форму группы, настоятельно рекомендую перевести в публичную страницу! Только паблики отображаются в блоке «интересные страницы» на страницах пользователей, чем привлекают, в среднем, 30% трафика. То есть потенциальные клиенты будут переходить в Вашу группу без затрат на рекламу с Вашей стороны.`
				},
				cover: {
					finish:false,
					name:"Обложка",
					val: false,
					point:6,
					text_yes: `В сообществе установлена обложка — это отличное решение! Главное, проверьте, чтобы важные элементы, такие как текст и логотип не заходили за «слепые зоны». \n\n На мобильных устройствах обложка обрезается на 196 пикселей с каждой стороны (если откроете обложку на компьютере, это примерно по 2 сантиметра слева и справа).`,
					text_no:`Рекомендуем установить обложку сообщества (зайдите в «управление сообществом» -> «обложка сообщества» -> «загрузить»), это повысит эффективность группы, ведь обложка отображается, как на мобильных устройствах, так и на ПК. \n\n Если разместить на нее предложение, от которого Ваш потенциальный клиент не сможет отказаться, то это повысит продажи и будет дополнительной точкой касания с целевой аудиторией!`
				},
				description: {
					finish:false,
					name:"Описание",
					val: false,
					point:6,
					text_yes: `Отличное описание сообщества. Кстати, его видно как в мобильной версии ВКонтакте, так и в полной.`,
					text_no: `У сообщества нет описания. Оно должно быть кратким и емким, ведь его будут читать и с мобильных устройств, и с ПК. Добавить его можно в разделе «управление сообществом» -> «описание сообщества».`
				},
				messages: {
					finish:false,
					name:"Сообщения",
					val: false,
					point:6,
					text_yes: `В сообществе включены сообщения. Это верное решение. Теперь, чтобы случайно не пропустить сообщения от потенциальных клиентов, установите на телефон официальное приложение VK Admin (доступно в плеймаркет и апстор). Тогда все события в сообществе будут приходить к вам на телефон.`,
					text_no:`В сообществе отсутствуют сообщения и это печально. Давайте подключим их сейчас! Перейдите: «управление сообществом» -> «сообщения» -> «включены». Тогда потенциальным покупателям будет в разы удобней с вами связаться).`
				},
				online: {
					finish:false,
					name:"Сообщество online",
					val: false,
					point:3,
					text_yes: `Прислушайтесь! Слышите? Это овации клиентов. Они благодарны за то, что администратор на связи чуть ли ни 24/7, ставя отметку «сообщество онлайн»!`,
					text_no: `Подписчики желают знать, когда их администратор сможет оперативно ответить на все вопросы. Поэтому не забывайте выставлять статус «сообщество онлайн», который включается в диалогах с сообществом.`
				},
				involvement: {
					finish:false,
					name:"Вовлечение",
					val: "low",
					point_low:0,
					point_average:4,
					point_normal:8,
					point_good:12,
					point_great:0,
					text_low: ``,
					text_average: ``,
					text_normal: ``,
					text_good: ``,
					text_great:"",
				},
				difference: {
					finish:false,
					name:"Частота публикаций",
					val: "low",
					point_low:0,
					point_average:6,
					point_normal:8,
					point_good:12,
					point_great:0,
					text_low: ``,
					text_average: ``,
					text_normal: ``,
					text_good: ``,
					text_great:"",	
				},
				reposts: {
					finish:false,
					name:"Репосты",
					val: "low",
					point_low:0,
					point_average:6,
					point_normal:8,
					point_good:0,
					point_great:0,
					text_low: `В сообществе есть репосты. Умная лента любит уникальный контент, иными словами, все то, что публикуется не от имени группы (а репосты с личной страницы сюда также относятся) снижается в новостной ленте и все меньшему числу подписчиков отображается. Поэтому с репостами пора завязывать.`,
					text_average: `В сообществе есть небольшое количество репостов. Это допустимо, если администратор добавляет к ним подробное описание: почему подписчикам будет полезна эта информация, иначе алгоритмы умной ленты данные публикации занизят в выдаче.`,
					text_normal: `Как здорово, что посты пишутся от имени группы, а не репостятся с других источников! Алгоритмы ВКонтакте благодарят сообщество и поднимают в умной ленте, т.е. новости группы видит все большее количество подписчиков!`,
					text_good: "",
					text_great: "",	
				},
				hashtag: {
					finish:false,
					name:"Хештеги",
					val: false,
					point:6,
					text_yes: `В сообществе не используются хештеги и это правильно. Увы, но ВКонтакте не покупают через хештеги. Их целесообразно использовать только для навигации в группе, например, #игра@itmarketer`,
					text_no: `Как давно Вы покупали товар или услугу, забив в поиск хештег ВКонтакте? Спросите об этом у 10 знакомых. За 2 года я не нашла ни одного человека, который купил что-либо через хештеги в этой социальной сети. Более того, если Вы их используете 10 и более, то запись не покажется ни по одному из них! Зато Ваших конкурентов потенциальные клиенты увидят во всей красе).`
				},
				market: {
					finish:false,
					name:"Товары",
					val: false,
					point:6,
					text_yes: `В сообществе подключен раздел «товары». Теперь покупать товары и услуги можно, не выходя из VK, для этого можно подключить к сообществу VK Pay (не обязательно иметь юр. лицо).`,
					text_no: `На текущий момент сообщество не использует раздел «товары» и потенциальным клиентам приходится тратить больше времени на поиск прайса и предлагаемых товаров/услуг. Часть из них уходит, так и не найдя ответа на свой вопрос. Обязательно подключите их через «управление группой» -> «разделы» -> «товары».`
				},
				main_section: {
					finish:false,
					name:"Главная секция",
					val: false,
					point:8,
					text_yes: `В сообществе выбрана главная секция. Администратор умеет управлять вниманием потенциального клиента!`,
					text_no: `ВКонтакте можно управлять вниманием потенциального клиента. Дело в том, что появилась возможность выбрать главную секцию сообщества! Что для вас важно в первую очередь: фото, видео, обсуждения или товары? Именно этот блок будет отображаться выше остальных! \n\n Для установки главной секции перейдите в управление сообществом -> «разделы» -> «главный блок».`
				},
				links: {
					finish:false,
					name:"Ссылки",
					val: false,
					point:6,
					text_yes: `В разделе «ссылки» нет ссылок на внешние источники, в том числе инстаграм/ютуб/сайт компании. Это правильно! \n\n Если человек заинтересовался Вашим товаром, а после перешел на Ваш инстаграм из группы, далее нажал на хештег и пошел гулять по просторам интернета, то вероятней всего он забудет, с чего все началось и совершит покупку у конкурентов. Поэтому ссылки могут вести только на разделы данной группы.`,
					text_no: `В разделе «ссылки» располагаются внешние источники, иными словами, если человек заинтересовался Вашим товаром, а после перешел на Ваш инстаграм из группы, далее нажал на хештег и пошел гулять по просторам интернета, то, вероятней всего, он забудет, с чего все началось, и совершит покупку у конкурентов. Поэтому сторонние ссылки лучше убрать из данного блока.`
				},
				contacts: {
					finish:false,
					name:"Контакты",
					val: false,
					point:6,
					text_yes: `Администратор заботится о потенциальных клиентах. Многие предпочитают обратиться к конкретному лицу, а не бренду в целом для решения вопросов. Это здорово, что в блоке «контакты» находятся люди, а не безликий номер телефона.`,
					text_no: `Вы встречали фразу, что люди покупают у людей? 90% в соцсети строится на этом утверждении, именно поэтому важно в контакты ставить ссылки на пользователей, которые смогут оперативно подсказать по вопросам клиентов.`
				},
			}
		};
export default result_obj;


// WEBPACK FOOTER //
// ./src/scan.js